import { createSelector } from "reselect";

import getScanDataset from "./get_scan_dataset";

const getScanDate = createSelector([
  getScanDataset
], (scanDataset) => scanDataset?.scanDate || null);

export default getScanDate;
